<template>
	<el-carousel v-loading="loading" :height="height" indicator-position="none" class="layout_banner">
		<el-carousel-item v-for="(item, index) in list" :key="index">
			<el-image style="width: 100vw; height: 100%;" :src="item.banner_id ? $http.fileUrl + item.file_path : require('@/assets/' + item.file_path)" fit="cover"></el-image>
		</el-carousel-item>
	</el-carousel>
</template>

<script>
import {mapGetters} from "vuex";
import {getBannerPicListApi} from "@/api";
import {Message} from "element-ui";

export default {
	name: "index",
	props: {
		height: {
			type: String,
			default: "200px"
		},
	},
	data() {
		return {
			loading: false,
			list: []
		}
	},
	computed: {
		...mapGetters(["navOptions"])
	},
	watch: {
		"route.name"() {
			this.getBannerList();
		}
	},
	created() {
		this.getBannerList();
	},
	methods: {
		async getBannerList() {
			let name = this.$route.name;
			let cItem = this.navOptions.filter( item => name.includes(item.name) )[0];
			if(cItem) {
				// this.loading = true;
				const res = await getBannerPicListApi(cItem.type);
				this.list = res.data;
				// this.loading = false;
			}else {
				this.list = [{
					file_path: "cooperative_banner.jpg"
				}];
				// Message.error("无效的类型");
				// this.$modal.msgError("无效的类型");
			}
		}
	}
}
</script>

<style lang="less" scoped>
.layout_banner {
	width: 100%;
}
</style>
